<script>
import {authComputed} from "@state/helpers";

export default {
  props: {
    camera: {
      type: Object,
      required: true,
    },
    loadingSize: {
      type: String,
      default: '100px',
    },
    image: {
      type: String,
      required: false,
      default: ''
    },
    inTour: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...authComputed
  },
  methods: {
    onClick(event){
      this.$emit('click', event);
    }
  },
}
</script>

<template>
  <div
    :class="$style.panorama"
  >
    <div :class="$style.overlayBox">
      <img v-if="image" :src="image" :alt="'Panorama image ' + camera.name" @click="onClick"/>
      <div v-if="!inTour" :class="$style.overlay"></div>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.overlayBox {
  position: relative; display: flex; justify-content: center; align-items: center;
}

.overlay {
  margin: 0;
  position: absolute;
}
.overlay::before {
  content: "";
  display: block;
  position: absolute;
  top: -20em;
  left: -20em;
  width: 40em;
  height: 40em;
  background: rgba(255,0,0,0.5);
}

.panorama {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  overflow: hidden;
  color: transparentize($color-white, 0.6);

  img {
    display: flex;
    max-width: 100%;
    max-height: 100%;
    cursor: pointer;
  }
}
</style>
